import { MainButton } from "./components/MainButton";
import useMenu from "./useMenu";
import GenericModal from "../components/GenericModal";

export default function Menu(props) {
  const { logout, login } = props;
  const {
    menu,
    showBlack,
    setShowBlack,
    writeButton,
    switchBox,
    screens,
    onClickMain,
    dialogStatus,
    closeDialog,
    openDialog,
    btnAvatar,
    inputList,
    avaButtons,
    closeMainMsg,
    msgType,
    writeAvatars,
    eventsData,
  } = useMenu({ logout, login });

  return (
    <div className="menu">
      <div style={{ position: "relative", flex: 1 }}>
        {screens.map(({ id, Comp, ...rest }) => (
          <Comp key={id} width={menu[id].width} {...rest} />
        ))}
      </div>
      <div className="menuBar">
        {writeButton(0)}
        <MainButton
          {...props}
          btnAvatar={btnAvatar}
          switchBox={switchBox}
          setShowBlack={setShowBlack}
          onClickMain={onClickMain}
          openDialog={openDialog}
        />
        {writeButton(2)}
      </div>
      <div
        onClick={() => setShowBlack(false)}
        className="blackScreen"
        style={{
          height: showBlack ? "100%" : 0,
        }}
      />
      <GenericModal
        open={dialogStatus[0]}
        data={{ inputList: inputList, buttons: avaButtons }}
        close={closeDialog}
      >
        {writeAvatars()}
      </GenericModal>
      <GenericModal
        open={dialogStatus[1]}
        data={msgType[dialogStatus[1]]}
        close={closeMainMsg}
      />
      <GenericModal
        open={eventsData.length > 0}
        data={msgType.eventMsg}
        close={closeMainMsg}
      />
    </div>
  );
}
